import { Route } from "react-router-dom";

import { VIEW_ALL_TASK, VIEW_ASSIGNED_TASK } from "src/constants";
import { TASK_ROUTES } from "src/pages/task/constants";
import { ProtectedRoute } from "src/utils/ProtectedRoute";

import { SingleTask } from "./SingleTask.page";
import { Task } from "./Task.page";

/** Route tree for the task module, mounted under `/tasks`. */
export const taskRoutes = (
  <>
    <Route
      path={TASK_ROUTES.root}
      element={<ProtectedRoute permissions={[VIEW_ALL_TASK, VIEW_ASSIGNED_TASK]} component={Task} />}
    />
    <Route
      path={TASK_ROUTES.progress}
      element={<ProtectedRoute permissions={[VIEW_ALL_TASK, VIEW_ASSIGNED_TASK]} component={SingleTask} />}
    />
  </>
);
